/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {BannerEl} from 'common/components/banner';
import type {ReportMessageBanner} from 'common/widgets/report-message-banner/index';
import {BannerAction} from 'common/components/banner/types';

export function template(this: ReportMessageBanner) {
  const {visible} = this.state;

  return (
    <div
      sel='.mp-message-banner-container'
      class={{
        'mp-message-banner-visible': visible,
      }}
    >
      {visible && (
        <BannerEl
          attrs={{
            theme: this.attr(`type`),
            'header-text': this.attr(`title`),
            'body-text': this.attr(`message`),
            size: this.attr(`size`),
            ctas: this.attr(`closeable`)
              ? [
                  {
                    text: `Dismiss`,
                    actionName: BannerAction.Dismiss,
                  },
                ]
              : [],
          }}
          on={{
            action: this.helpers.hideBanner,
          }}
        />
      )}
    </div>
  );
}
